import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 pb-28 pt-8 sm:pb-10" data-id="element-76" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-2xl px-4 text-center" data-id="element-77" data-mp="3gfiu2hdxs9dl">
        <div className="flex items-center justify-center gap-2" data-id="element-78" data-mp="32nulgo2wc31d">
          <span className="font-display text-lg font-bold text-white" data-id="element-79" data-mp="32pp6s3i2xx5z">Dra.</span>
          <span className="font-display text-lg font-bold text-gold-400" data-id="element-80" data-mp="36q92d2n08sq0">Karito</span>
        </div>
        <p className="mt-3 text-[12px] leading-relaxed text-cream-100/60" data-id="element-81" data-mp="3ugbt9ff6nsn1">
          Sistema Maestro de TRT™ — material de consulta clínica dirigido exclusivamente a
          profesionales de la salud. No sustituye el juicio clínico ni constituye consejo
          médico para pacientes.
        </p>
        <p className="mt-3 text-[11px] text-cream-100/45" data-id="element-82" data-mp="3qc3zh3tvbmhy">
          *Las actualizaciones futuras se entregan por el mismo medio de descarga.
        </p>
        <p className="mt-4 text-[11px] text-cream-100/45" data-id="element-83" data-mp="2ey9wnok2abk6">
          © {new Date().getFullYear()} Decisión Clínica. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}